import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";
export const DocumentoList = props => <DefaultDataTable data={props} />;
